// extracted by mini-css-extract-plugin
export var container = "_96-0";
export var error = "_96-9";
export var label = "_96-5";
export var light = "_96-6";
export var md = "_96-3";
export var sm = "_96-2";
export var thin = "_96-8";
export var thinBold = "_96-7";
export var vertical = "_96-4";
export var xs = "_96-1";